import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useAtomValue } from 'jotai';
import { GetServerSideProps } from 'next';
import { ReactElement, ReactNode, useMemo } from 'react';

import { DefaultLayout } from '@/components/layout/Layout.tsx';
import { QueueContent } from '@/components/tax-refund/lookup/queue/QueueContent';
import { hometaxBlockSettingsAtom } from '@/lib/stores/hometax-block.ts';
import { BusinessType } from '@/lib/types/request.ts';
const QueuePage = ({ businessType }: { businessType: BusinessType }) => {
  const settings = useAtomValue(hometaxBlockSettingsAtom);

  if (!settings?.data) return null;
  return (
    <PageViewEventLogger
      pageName={'lookup_waiting'}
      eventProperty={{
        type: businessType,
        timing: settings.data?.queueScreenStage?.toLowerCase()
      }}
    >
      <QueueContent businessType={businessType} />
    </PageViewEventLogger>
  );
};

const QueueLayout = ({ businessType, children }: { businessType: BusinessType; children: ReactNode }) => {
  const settings = useAtomValue(hometaxBlockSettingsAtom);

  const clickEvents = useMemo(
    () => ({
      exitTextButton: {
        name: 'lookup_waiting_close',
        attributes: {
          type: businessType,
          timing: settings.data?.queueScreenStage?.toLowerCase()
        }
      }
    }),
    [businessType, settings.data?.queueScreenStage]
  );

  return (
    <AuthGuard>
      <DefaultLayout rightItems={['exitTextButton']} clickEvents={clickEvents}>
        {children}
      </DefaultLayout>
    </AuthGuard>
  );
};

QueuePage.getLayout = (page: ReactElement, pageProps: { businessType: BusinessType }) => {
  return <QueueLayout businessType={pageProps.businessType}>{page}</QueueLayout>;
};

export const getServerSideProps = (async ({ query }) => {
  let businessType: BusinessType = 'indis';
  if (query?.type === 'corps' || query?.type === 'indis') {
    businessType = query.type as BusinessType;
  }
  return { props: { businessType } };
}) satisfies GetServerSideProps;

export default QueuePage;
